var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"s-component"},[_vm._t("default"),_c('SModalTip',{ref:"SModalTip"}),_c('SModalReceiveLog',{ref:"SModalReceiveLog"}),_c('SModalAddress',{ref:"SModalAddress"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }